import { createContext } from 'react';
import { EnvSettings } from '@e2m-customer-portal/shared';

export const EnvSettingsContext = createContext<EnvSettings | null>(null);
